import { PeoPayrollProviderInfoFragment } from 'src/api';

import {
  CompanyInformationFormPeoPayrollProviderFields,
  CompanyInformationFormPeoPayrollProviderValues,
} from '../types';

export const getInitialValues = (
  peoPayrollProvider: PeoPayrollProviderInfoFragment,
): CompanyInformationFormPeoPayrollProviderValues => {
  return {
    [CompanyInformationFormPeoPayrollProviderFields.displayName]: peoPayrollProvider.displayName,
    [CompanyInformationFormPeoPayrollProviderFields.industry]: peoPayrollProvider.industry,
    [CompanyInformationFormPeoPayrollProviderFields.contactEmail]: peoPayrollProvider.contactEmail,
    [CompanyInformationFormPeoPayrollProviderFields.contactPhoneNumber]:
      peoPayrollProvider.contactPhoneNumber,
    [CompanyInformationFormPeoPayrollProviderFields.taxYearEndDate]:
      peoPayrollProvider.taxYearEndDate,
    [CompanyInformationFormPeoPayrollProviderFields.corporateStructure]:
      peoPayrollProvider.corporateStructure,
    [CompanyInformationFormPeoPayrollProviderFields.numberOfEmployees]:
      peoPayrollProvider.numberOfEmployees,
    [CompanyInformationFormPeoPayrollProviderFields.fein]: peoPayrollProvider.fein,
    [CompanyInformationFormPeoPayrollProviderFields.defaultDisclaimer]:
      peoPayrollProvider.defaultDisclaimer,
    [CompanyInformationFormPeoPayrollProviderFields.logoFile]: peoPayrollProvider.logo
      ? { id: peoPayrollProvider.logo.id, size: peoPayrollProvider.logo.size }
      : null,
    [CompanyInformationFormPeoPayrollProviderFields.headquarters]: peoPayrollProvider.headquarters,
  };
};
